<template>
  <div id="picker" @click="cancelEvent">
    <div id="picker-view" >

      <div class="picker-view-header">
        <div class="picker-view-lable picker-view-lable-cancel" @click="cancelEvent">取消</div>
        <div class="picker-view-lable picker-view-lable-commit" @click="commitEvent">确认</div>
      </div>
      <div class="picker-wrapper">
        <mt-picker :slots="pickerData" @change="onValueChange" :visible-item-count="5"></mt-picker>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['dataSlots'],
    data () {
      return {
        selectData: [],
        pickerData: [{
                flex: 1,
                values: [],
                className: 'slot1',
                textAlign: 'right'
              }, {
                divider: true,
                content: '-',
                className: 'slot2'
              }, {
                flex: 1,
                values: [],
                className: 'slot3',
                textAlign: 'left'
              }]
      }
    },
    methods: {
      cancelEvent () {
        var eventObj = {}
        eventObj.isShow = false
        this.$emit('picker-event', eventObj);
      },
      onValueChange (picker, values) {
        for (var i in values) {
          var val = values[i]
          if (val !== undefined) {
            this.selectData[i] = values[i]
          }
        }
      },
      commitEvent () {
        var eventObj = {}
        eventObj.isShow = false
        eventObj.selectData = this.selectData
        this.$emit('picker-event', eventObj);
      }
    },
    mounted () {
      var selectData = []
      this.pickerData[0].values = this.dataSlots[0].values;
      this.pickerData[2].values = this.dataSlots[1].values;
      for (var i in this.dataSlots) {
        var obj = this.dataSlots[i]
        console.log(obj)
        if (obj.hasOwnProperty('values')) {

          if (obj.hasOwnProperty('defaultIndex')) {
            selectData.push(obj.values[obj.defaultIndex])
          } else if (obj.values.length > 0) {
            selectData.push(obj.values[0])
          }

        }
      }
      this.selectData = selectData
      console.log(selectData)
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/css/mixin';


  #picker {
    background: rgba(25,25,25,0.30);
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 666;
  }
  #picker-view {
    position: absolute;
    height: pxToRem(470px);
    background-color: #EEEEEE;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }
  #picker-wrapper {
    bottom: 0px;
    top: pxToRem(100px);
    background-color: #EEEEEE;
  }
  .picker-view-header {
    height: pxToRem(100px);
    background-color: white;
    left: 0;
    right: 0;
    top: 0;

  }
  .picker-center-highlight:before, .picker-center-highlight:after {
    background-color: #BDBDBD;
  }
  .picker-items {
    background-color: #EEEEEE;
  }
  .picker-view-lable {
    color: #191919;
    font-size: pxToRem(24px);
    height: pxToRem(100px);
    line-height: pxToRem(100px);
    display: inline-block;
  }
  .picker-view-lable-commit {
    margin-left: pxToRem(576px);
  }
  .picker-view-lable-cancel {
    margin-left: pxToRem(40px);
  }
  
  
</style>


// WEBPACK FOOTER //
// Picker.vue?c4a4711a